import { Promotion } from 'ui/components/3-organisms/Promotion';

export const PromotionFeature: React.FC<Umbraco.Promotion> = ({ content, settings }) => {
	return <Promotion {...content?.properties} {...settings?.properties} />;
};
